import { CSSObject } from "@emotion/react";
import { transparentize } from "polished";
import { Colors } from "../design-tokens/colors";
import { grid } from "../design-tokens/grid";

const root: CSSObject = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  paddingTop: grid(2),
  paddingBottom: grid(2),

  "> img": {
    maxHeight: "100%",
  },
};

const rootCover: CSSObject = {
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  alignItems: "flex-start",
  backgroundColor: transparentize(0.25, Colors.White),
  paddingTop: grid(6),
  zIndex: 20,
};

const styles = {
  root,
  rootCover,
};

export default styles;
